// extracted by mini-css-extract-plugin
module.exports = {"submit":"send-request-module__submit___XDHbk","container":"send-request-module__container___mn+tu"};